export default __webpack_public_path__ + "static/media/RPG_6.5baa44fd.png";